// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2mOSm","choiceBoxes":"toolbarselects_choiceBoxes__HEI52","simpleField":"toolbarselects_simpleField__1pwta"};